export function validarData(date) {
  var matches = /(\d{4})[-.\/](\d{2})[-.\/](\d{2})/.exec(date);
  if (matches == null) {
    return false;
  }
  var dia = matches[3];
  var mes = matches[2] - 1;
  var ano = matches[1];
  var data = new Date(ano, mes, dia);
  return data.getDate() == dia && data.getMonth() == mes && data.getFullYear() == ano;
}

export function formatarDataBr(data) {
  const partes = data.split('-');
  const ano = partes[0];
  const mes = partes[1];
  const dia = partes[2];

  return `${dia}/${mes}/${ano}`;
}

export function validarSaidaDate(value) {
  const selectedDate = new Date(value);
  const today = new Date();
  const minDate = new Date();
  minDate.setMonth(today.getMonth() - 5); // Subtrai 5 meses

  if (selectedDate > today) {
    return 'A data não pode ser maior que hoje';
  }
  if (selectedDate < minDate) {
    return 'A data não pode ser menor que 5 meses atrás';
  }
  return true;
}
